import React, { useState, useEffect } from 'react';
import './QuotaFullScreen.css';

export default function QuotaFullScreen({ panelId, onRedirect, quotaInfo }) {
  const [countdown, setCountdown] = useState(3);

  // Countdown und Auto-Redirect nur wenn Panel-ID vorhanden
  useEffect(() => {
    if (!panelId || !onRedirect) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [panelId, onRedirect]);

  return (
    <div className="quota-screen-overlay">
      <div className="quota-screen-container">
        {/* Info Icon */}
        <div className="quota-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#ffa726" strokeWidth="2"/>
            <path d="M12 8v4M12 16h.01" stroke="#ffa726" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="quota-title">
          Vielen Dank für Ihr Interesse!
        </h1>

        <p className="quota-message">
          Die maximale Teilnehmerzahl für diese Umfrage wurde bereits erreicht.
        </p>

        <p className="quota-submessage">
          Wir bedanken uns für Ihr Interesse und freuen uns über zukünftige Teilnahmen.
        </p>

        {/* Countdown für Panel-Teilnehmer */}
        {panelId && (
          <div className="redirect-countdown">
            <p className="redirect-message">
              Sie werden in <strong>{countdown}</strong> Sekunde{countdown !== 1 ? 'n' : ''} automatisch weitergeleitet...
            </p>
          </div>
        )}

        {/* Fallback Link wenn kein Panel */}
        {!panelId && (
          <a
            href="https://fairment.de"
            target="_blank"
            rel="noopener noreferrer"
            className="quota-button"
          >
            Zu fairment.de
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 3L13 10L7 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        )}
      </div>
    </div>
  );
}

